import React, {useEffect, useRef, useState} from 'react';
import {findEnabledWalkInCustomersByQueryString, insertCustomer} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import {formatPhoneNumber} from "../../core/telephone";
import ActionButtonsManagerView from "../common/ActionButtonsManagerView";

const SaleManagerTakeAway = ({isDelivery}) => {
    const [customers, setCustomers] = useState([]);
    const [filteredCustomers, setFilteredCustomers] = useState([]);
    const [phoneInput, setPhoneInput] = useState('');
    const [nameInput, setNameInput] = useState('');
    const inputPhone = useRef(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    }

    function onlyDigits(str) {
        return (str || '').replace(/\D/g, '');
    }

    async function makeQuery() {
        try {
            setLoading(true);
            const result = await findEnabledWalkInCustomersByQueryString('');
            setCustomers(result || []);
            setFilteredCustomers(result || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputPhone.current) {
            inputPhone.current.focus();
        }
        makeQuery();
    }, []);

    const handlePhoneChange = (e) => {
        const value = e.target.value;
        const digits = onlyDigits(value);
        setPhoneInput(value);
        const filtered = customers.filter((c) =>
            onlyDigits(c.phone).includes(digits) || removeSpecialChars(c.name).includes(removeSpecialChars(digits))
        );
        setFilteredCustomers(digits === '' ? customers : filtered);
    };

    async function selectCustomer(customer) {
        const sale = {customer: customer, isDelivery: !!isDelivery};

        if (isDelivery) {
            sale.deliveryZipCode = customer.deliveryZipCode;
            sale.deliveryStreet = customer.deliveryStreet;
            sale.deliveryNumber = customer.deliveryNumber;
            sale.deliveryComplement = customer.deliveryComplement;
            sale.deliveryReference = customer.deliveryReference;
            sale.deliveryNeighborhood = customer.deliveryNeighborhood;
        }

        localStorage.setItem('sale', JSON.stringify(sale));
        navigate("/sale/items");
    }

    async function startNewOrder() {
        const name = nameInput.trim();
        const phone = onlyDigits(phoneInput);

        if (phone.length < 10) {
            alert('Informe um telefone válido, com DDD.');
            return;
        }

        const existingCustomer = customers.find((c) => onlyDigits(c.phone) === phone);
        if (existingCustomer) {
            await selectCustomer(existingCustomer);
            return;
        }

        if (name === '') {
            alert('Informe o nome do cliente.');
            return;
        }

        try {
            setLoading(true);
            const customer = await insertCustomer({name: name.toUpperCase(), phone, walkIn: true, enabled: true});
            await selectCustomer(customer);
        } catch (error) {
            console.error('Error creating walk-in customer:', error);
            alert('Não foi possível iniciar o pedido.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <>
            <div className="header-label">{isDelivery ? 'Delivery' : 'Take Away'}</div>

            <div style={{marginBottom: '5px'}}>Telefone:</div>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}
                 className="input-container">
                <input style={{width: '100%'}} ref={inputPhone} type="text" value={phoneInput}
                       onChange={handlePhoneChange} onFocus={(event) => event.target.select()}
                       inputMode="numeric"/>
                <button id="clearButton" onClick={() => {
                    setPhoneInput('');
                    setFilteredCustomers(customers);
                    inputPhone.current.focus();
                }}>X
                </button>
            </div>

            {phoneInput !== '' && filteredCustomers.length > 0 &&
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '250px'}}/>
                        <col style={{width: '150px'}}/>
                        <col style={{width: '50px'}}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Telefone</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody style={{overflowY: 'auto'}}>
                    {filteredCustomers.map((customer, index) => (
                        <tr key={index}>
                            <td>
                                <div>{customer.name}</div>
                            </td>
                            <td>
                                <div>{formatPhoneNumber(customer.phone)}</div>
                            </td>
                            <td>
                                <button onClick={() => selectCustomer(customer)}>Selecionar</button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            }

            <div style={{marginTop: '15px'}}>
                <div style={{marginBottom: '5px'}}>Novo cliente:</div>
                <div className="input-container" style={{width: '100%'}}>
                    <input style={{width: '100%'}} type="text" value={nameInput}
                           onChange={(e) => setNameInput(e.target.value.toUpperCase())}
                           placeholder="Nome do cliente"/>
                </div>
            </div>

            <ActionButtonsManagerView>
                <button onClick={startNewOrder} disabled={loading}>Iniciar Pedido</button>
            </ActionButtonsManagerView>
        </>
    );
};

export default SaleManagerTakeAway;
